import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

export default function Footer() {
  return (
    <footer style={{ borderTop: '1px solid var(--border)', backgroundColor: 'var(--bg-surface)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-8">
          {/* Brand */}
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-xl border-2 border-gray-900 bg-white">
                <ArrowUpRight className="h-4 w-4 text-[#17A24A]" strokeWidth={2.5} />
              </span>
              <span className="text-sm font-bold" style={{ color: 'var(--text-primary)' }}>ParkingRank</span>
            </div>
            <p className="text-sm max-w-xs leading-relaxed" style={{ color: 'var(--text-muted)' }}>
              Independent exit scores for garages near major venues. Park smarter, leave faster.
            </p>
          </div>

          {/* Links */}
          <div className="flex gap-12">
            <div className="space-y-3">
              <p className="text-xs font-semibold uppercase tracking-wide" style={{ color: 'var(--text-muted)' }}>
                Directory
              </p>
              <div className="flex flex-col gap-2">
                <Link to="/garages" className="text-sm transition-colors" style={{ color: 'var(--text-secondary)' }}>Garages</Link>
                <Link to="/events" className="text-sm transition-colors" style={{ color: 'var(--text-secondary)' }}>Events</Link>
                <Link to="/teams" className="text-sm transition-colors" style={{ color: 'var(--text-secondary)' }}>Teams</Link>
                <Link to="/cities" className="text-sm transition-colors" style={{ color: 'var(--text-secondary)' }}>Cities</Link>
              </div>
            </div>
            <div className="space-y-3">
              <p className="text-xs font-semibold uppercase tracking-wide" style={{ color: 'var(--text-muted)' }}>
                About
              </p>
              <div className="flex flex-col gap-2">
                <Link to="/methodology" className="text-sm transition-colors" style={{ color: 'var(--text-secondary)' }}>Methodology</Link>
                <Link to="/blog" className="text-sm transition-colors" style={{ color: 'var(--text-secondary)' }}>Blog</Link>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-6 flex flex-col sm:flex-row justify-between items-center gap-3" style={{ borderTop: '1px solid var(--border)' }}>
          <p className="text-xs" style={{ color: 'var(--text-muted)' }}>© 2026 ParkingRank</p>
          <p className="text-xs" style={{ color: 'var(--text-muted)' }}>4,700+ garages · 350+ venues · 196 cities</p>
        </div>
      </div>
    </footer>
  );
}
